import { useQuery } from 'react-query';
import { logger } from '@parrot-software/observability';

import { getConfigUseCases } from '@onboarding/composition';
import type { StoreAdminInfoDto } from '@onboarding/application/dtos';

const onbLog = logger.forDomain('ONB');

/**
 * Fetches the store admin info snapshot used to pre-fill the receipt step.
 *
 * Cached under ['onboarding', 'store-admin-info'] with infinite stale time so
 * it runs at most once per wizard session. Retries are disabled to surface
 * failures immediately to the presentation layer.
 */
export const useStoreAdminInfo = () => {
  const { fetchStoreAdminInfo } = getConfigUseCases();

  return useQuery<StoreAdminInfoDto, Error>(['onboarding', 'store-admin-info'], () => fetchStoreAdminInfo.execute(), {
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    retry: false,
    onError: (error) => {
      onbLog.warn('store_admin_query_error', {
        'error.kind': error.constructor?.name ?? 'UnknownError',
        'error.message': error.message,
      });
    },
  });
};
